export const paths = {
    HOME: '/',
    ABOUT: '/about-joshua',
    PROJECTS: '/projects'
}